import { AbstractControl, ValidatorFn, ValidationErrors } from "@angular/forms";

export const existeValorDuplicado = (
  control: any,
  catalogo: any[],
  currentValue: string
) => {
  const controlName =
    control.parent && control.parent.controls
      ? Object.keys(control.parent.controls).find(
          (name) => control.parent.get(name) === control
        )
      : null;
  const valorControl = control;
  const nuevoValor = valorControl?.value?.toLowerCase() || "";
  const valoresCatalogo = catalogo.map((cat: any) =>
    cat[`${controlName}`].toLowerCase()
  );
  let errors = control?.errors || {};
  const erroKey = controlName + "Duplicad@";

  if (nuevoValor && nuevoValor === currentValue.toLowerCase()) {
    delete errors[erroKey];
  } else if (valoresCatalogo.some((valor) => valor === nuevoValor)) {
    errors = { ...errors, [erroKey]: true };
  } else if (!nuevoValor) {
    errors = { ...errors, required: true };
  } else {
    delete errors[erroKey];
  }
  valorControl?.setErrors(Object.keys(errors).length ? errors : null);
};

export const emailPatternValidator = (): ValidatorFn => {
  const pattern =/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    const valid = pattern.test(control.value);
    return valid ? null : { invalidEmail: true };
  };
};

export const campoRequerido = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value == null || control.value.trim().length === 0) {
      return { campoRequerido: true };
    }
    return null;
  };
};

export const nombreUsuario = (): ValidatorFn => {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const valor = control.value;
    const pattern = /^[a-zA-Z ñàäáèëéìïíòöóùüú´ÑÀÄÁÈËÉÌÏÍÒÖÓÙÜÚ]+$/;
    if (valor && !pattern.test(valor)) {
      return { nombreUsuario: true };
    }
    return null;
  };
};

export const nombreRemitente = (): ValidatorFn => {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const valor = control.value;
    const pattern = /^[a-zA-Z\sáéíóúÁÉÍÓÚñÑäëïöüÄËÏÖÜàèìòùÀÈÌÒÙ\.\-']*$/;
    if (valor && !pattern.test(valor)) {
      return { nombreRemitente: true };
    }
    return null;
  };
};

export const descripcionCatalogo = (): ValidatorFn => {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const valor = control.value;
    const pattern = /^[A-Za-záéíóúÁÉÍÓÚñÑäëïöüÄËÏÖÜ0-9\s]+$/;
    if (valor && !pattern.test(valor)) {
      return { descripcionCatalogo: true };
    }
    return null;
  };
};